/* unplugin-vue-components disabled */import script from "./Bdtcl.vue?vue&type=script&lang=ts&setup=true"
export * from "./Bdtcl.vue?vue&type=script&lang=ts&setup=true"

import "./Bdtcl.vue?vue&type=style&index=0&id=b89dfec6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b89dfec6"]])

export default __exports__